<template>
    <div class="app-page">
        <router-view />
    </div>
</template>

<script lang="ts">
import { onMounted, ref } from "vue";

export default {
    name: "App",
    setup() {
        return {};
    }
};
</script>

<style lang="scss">
.app-page {
    display: flex;
}
</style>
